import { render } from "./PartnerRequestTableHeader.vue?vue&type=template&id=3c17aff3&scoped=true"
const script = {}

import "./PartnerRequestTableHeader.vue?vue&type=style&index=0&id=3c17aff3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c17aff3"]])

export default __exports__